import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/HelpCenter.css";

const HelpCenter = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  const faqCategories = [
    {
      title: "시작하기",
      faqs: [
        {
          question: "계정은 어떻게 만드나요?",
          answer:
            "홈페이지 우측 상단의 '회원가입' 버튼을 클릭하세요. 이메일을 입력하고 비밀번호를 생성한 후, 이메일로 전송된 인증 단계를 따라 완료하시면 됩니다.",
        },
        {
          question: "토익 연습은 어떻게 시작하나요?",
          answer:
            "로그인 후, 대시보드에서 연습 테스트에 접근할 수 있습니다. 리딩이나 리스닝과 같은 다양한 섹션 중에서 선택하여 연습을 시작하세요.",
        },
      ],
    },
    {
      title: "이용권 및 결제",
      faqs: [
        {
          question: "이용권은 어떻게 구매하나요?",
          answer:
            "로그인 후 '이용권 구매' 페이지에서 한달 이용권을 구매하실 수 있습니다. 결제는 한 번만 이루어지며 자동 갱신되지 않습니다.",
        },
        {
          question: "어떤 결제 방법을 지원하나요?",
          answer:
            "주요 신용카드(비자, 마스터카드, 아메리칸 익스프레스)와 페이팔을 지원합니다.",
        },
      ],
    },
    {
      title: "기술 지원",
      faqs: [
        {
          question: "리스닝 테스트에서 오디오가 재생되지 않아요",
          answer:
            "먼저 기기의 볼륨과 브라우저 권한을 확인하세요. 문제가 지속되면 다른 브라우저를 사용하거나 캐시를 지워보세요.",
        },
        {
          question: "비밀번호를 어떻게 재설정하나요?",
          answer:
            "로그인 페이지에서 '비밀번호 찾기'를 클릭하고 이메일로 전송된 안내에 따라 비밀번호를 재설정하세요.",
        },
      ],
    },
  ];

  return (
    <div className="help-center-page">
      <div className="logo" onClick={() => navigate("/")}>
        TOEICMON
      </div>

      <div className="help-center-content">
        <div className="help-center-header">
          <h1>고객 지원 센터</h1>
          <p>토익몬에 관한 질문의 답을 찾아보세요</p>
          <div className="search-box">
            <input
              type="text"
              placeholder="도움말 검색..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        <div className="faq-categories">
          {faqCategories.map((category, index) => (
            <div key={index} className="faq-category">
              <h2>{category.title}</h2>
              <div className="faq-list">
                {category.faqs.map((faq, faqIndex) => (
                  <div key={faqIndex} className="faq-item">
                    <h3>{faq.question}</h3>
                    <p>{faq.answer}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="contact-support">
          <h2>아직 도움이 필요하신가요?</h2>
          <p>저희 지원팀에게 이메일을 보내주세요</p>
          <div className="support-email">
            <span className="email-text">support@toeicmon.com</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpCenter;
